import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useApi(url) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(Boolean(url));

  const reload = useCallback(() => {
    if (!url) return Promise.resolve();
    return api
      .get(url)
      .then((r) => {
        setData(r.data);
        setError(null);
      })
      .catch((e) => setError(e))
      .finally(() => setLoading(false));
  }, [url]);

  useEffect(() => {
    setLoading(true);
    reload();
  }, [reload]);

  return { data, error, loading, reload, setData };
}
